import TrafficOverallChangeMetric from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficOverallChangeMetric";

const overallChangeMetrics = new Set(Object.values(TrafficOverallChangeMetric));

export const isTrafficOverallChangeMetric = (metric: string): metric is TrafficOverallChangeMetric => {
    return overallChangeMetrics.has(metric as TrafficOverallChangeMetric);
};
